import cityAtlasImage from "../assets/project/CityAtlas.png";
import codeOrbitImage from "../assets/project/CodeOrbit.png";
import hackerzzLobbyImage from "../assets/project/Hackerzz Lobby.png";
import saarthiImage from "../assets/project/SAARTHI.png";
import semanticaImage from "../assets/project/Semantica.png";
import smartFactoryImage from "../assets/project/Smart Factory Emission Monitoring.png";
import smartPriceImage from "../assets/project/SmartPrice Analytics.png";
import streamingEnforcementImage from "../assets/project/Streaming Subscription Enforcement.png";

const escapeXml = (value) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");

const svgDataUri = (svg) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

const makeLetterMark = ({ letter, width, height, accent = "#4e4a85" }) =>
  svgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
      <rect width="100%" height="100%" rx="28" fill="#181818" />
      <path d="M16 18 L${Math.round(width * 0.34)} 18 L${Math.round(width * 0.64)} ${Math.round(height * 0.62)} L${width - 16} ${Math.round(height * 0.62)} L${width - 16} ${height - 18} L${Math.round(width * 0.58)} ${height - 18} L16 ${Math.round(height * 0.36)} Z" fill="#202020" opacity="0.95" />
      <circle cx="${width / 2}" cy="${height / 2}" r="${Math.min(width, height) * 0.34}" fill="${accent}" fill-opacity="0.12" />
      <text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle" font-family="Georgia, 'Times New Roman', serif" font-size="${Math.min(width, height) * 0.72}" font-style="italic" font-weight="700" fill="#ffffff">${escapeXml(letter)}</text>
    </svg>
  `);

const makeBrandTile = ({ title, subtitle, initials, width, height, accent = "#4e4a85" }) =>
  svgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
      <rect width="100%" height="100%" rx="28" fill="#181818" />
      <rect x="16" y="16" width="${width - 32}" height="${height - 32}" rx="20" fill="none" stroke="${accent}" stroke-opacity="0.7" />
      <circle cx="${width / 2}" cy="${height / 2 - 20}" r="${Math.min(width, height) / 5}" fill="${accent}" fill-opacity="0.16" />
      <text x="50%" y="${height / 2 - 4}" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${Math.min(width, height) / 4.8}" font-weight="700" fill="#ffffff">${escapeXml(initials)}</text>
      <text x="50%" y="${height - 58}" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${Math.max(16, Math.min(width, height) / 10)}" font-weight="700" fill="#ffffff">${escapeXml(title)}</text>
      <text x="50%" y="${height - 30}" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${Math.max(10, Math.min(width, height) / 15)}" letter-spacing="2" fill="#8d8d8d">${escapeXml(subtitle)}</text>
    </svg>
  `);

export const profile = {
  name: "Sameer Kadam",
  role: "AI Systems & Backend Engineer | Distributed Systems | Semantic Retrieval | AI Infrastructure",
  summary:
    "AI systems and backend engineer focused on distributed systems, semantic retrieval, and AI infrastructure. I build event-driven backends with Java Spring Boot and Apache Kafka, streaming pipelines on Apache Spark and Delta Lake, and GraphRAG retrieval systems over knowledge graphs and vector stores. Currently an AI Systems & Backend Engineering Intern at Semantica, with 17+ merged pull requests across production open-source repositories.",
  location: "MIT Academy of Engineering, Alandi, Pune",
  phone: "+91 9960892130",
  email: "sskadam6305@gmail.com",
  leetcode: "https://leetcode.com/u/SKadam6305/",
  linkedin: "https://www.linkedin.com/in/sameerkadam6305/",
  github: "https://github.com/Sameer6305",
  resume:
    "https://drive.google.com/file/d/10H4GixbftNc3bzWHvh8KJbqe12w1rlnt/view?usp=drive_link",
};

export const education = {
  college: "MIT Academy of Engineering, Pune",
  degree: "B.Tech in Electronics and Telecommunication Engineering",
  expectedGraduation: "Expected May 2027",
  cgpa: "CGPA: 7.55 / 10.0",
};

export const skillTags = [
  "Java",
  "Java 8+",
  "Python",
  "SQL",
  "JavaScript",
  "TypeScript",
  "REST APIs",
  "FastAPI",
  "Flask",
  "Apache Spark",
  "Delta Lake",
  "PostgreSQL",
  "MySQL",
  "MongoDB",
  "Redis",
  "SPARQL",
  "pytest",
  "Git",
  "GitHub Actions",
  "Docker",
  "Cursor",
  "Microservices",
  "System Design",
  "Distributed Systems",
  "Event-Driven Architecture",
  "Message Queues",
  "Observability",
  "AI Infrastructure",
  "Semantic Retrieval",
  "GraphRAG",
  "Knowledge Graphs",
  "Retrieval Pipelines",
  "Context Engineering",
  "Provenance",
  "Evaluation Frameworks",
];

export const skillSummary =
  "AI systems and backend engineer focused on distributed systems, semantic retrieval, and AI infrastructure — building GraphRAG and retrieval pipelines over knowledge graphs and vector stores, provenance-aware context layers, and streaming systems on Spark and Delta Lake.";

export const certifications = [
  "Oracle Cloud Infrastructure 2025 Certified AI Foundations Associate - Oracle University (Jan 2026, valid until Jan 2028)",
  "SmartBird AI/ML Virtual Internship Certification - hands-on projects with Scikit-learn, TensorFlow, and Pandas",
];

export const achievements = [
  "UNESCO Youth Hackathon 2025 - International participation; submitted project on Youth Leading the Way: Building ML Solutions for Impact (Oct 2025, Cartagena, Colombia)",
  "DSA: 150+ problems solved on LeetCode and HackerRank (arrays, dynamic programming, trees)",
];

export const projectData = [
  {
    title: "Semantica",
    tech: "Python, GraphRAG, Apache AGE, pyvector, PostgreSQL, Snowflake",
    description:
      "Semantic retrieval engine combining vector similarity (HNSW) with an Apache AGE knowledge graph for GraphRAG-style context, plus transaction-safe writes and Snowflake batched ingestion.",
    link: "https://github.com/Sameer6305/semantica",
    image: semanticaImage,
  },
  {
    title: "Hackerzz Lobby",
    tech: "Flask, REST APIs, PostgreSQL, JWT",
    description:
      "Community and hackathon backend with authentication, AI summaries, and real-time integration.",
    link: "https://github.com/Sameer6305/Hackerzz_lobby",
    image: hackerzzLobbyImage,
  },
  {
    title: "CodeOrbit",
    tech: "Java, Spring Boot, REST APIs",
    description:
      "Code management and collaboration platform with real-time synchronization and version control.",
    link: "https://github.com/Sameer6305/CodeOrbit",
    image: codeOrbitImage,
  },
  {
    title: "CityAtlas",
    tech: "Java, Spring Boot, Apache Kafka, PostgreSQL",
    description:
      "City intelligence platform built on an event-driven architecture, with real-time Kafka stream processing, batch ETL, and separate OLTP and OLAP schemas.",
    link: "https://github.com/Sameer6305/CityAtlas",
    image: cityAtlasImage,
  },
  {
    title: "SmartPrice Analytics",
    tech: "Python, Data Processing, Analytics",
    description:
      "Price tracking and analytics engine with trend analysis, market insights, and predictive modeling.",
    link: "https://github.com/Sameer6305/SmartPrice-Analytics",
    image: smartPriceImage,
  },
  {
    title: "Streaming Subscription Enforcement",
    tech: "Kafka, Spark, Delta Lake, Redis, Python",
    description:
      "Distributed event-driven pipeline for subscription enforcement, with Spark streaming, Delta Lake storage, Redis-backed rate limiting, data quality checks, and billing analytics.",
    link: "https://github.com/Sameer6305/streaming-subscription-enforcement",
    image: streamingEnforcementImage,
  },
  {
    title: "Smart Factory Emission Monitoring",
    tech: "Python, FastAPI, ML",
    description:
      "Data ingestion, pollution recommendations, heatmap generation, and tested backend for factory emissions monitoring.",
    link: "https://github.com/Sameer6305/smart-factory-emission-monitoring",
    image: smartFactoryImage,
  },
  {
    title: "SAARTHI",
    tech: "Python, Flask, REST APIs",
    description:
      "Voice and reasoning agent with layered knowledge retrieval, context-aware command dispatching, and workflow execution.",
    link: "https://github.com/Sameer6305/SAARTHI",
    image: saarthiImage,
  },
];

export const openSourceData = [
  {
    title: "semantica - Hawksight-AI",
    tech: "Python, pyvector, Apache AGE, PostgreSQL, Snowflake, Apache Arrow",
    date: "Feb 2026",
    bullets: [
      "Merged 4 pull requests covering vector store similarity, HNSW indexing, Apache AGE graph backend, and transaction-safe writes.",
      "Added Snowflake batched ingestion and Apache Arrow export support.",
    ],
  },
  {
    title: "pocketpaw / conveyor (open-ug) / medcore",
    tech: "Python, PHP, NATS",
    date: "Jan - Feb 2026",
    bullets: [
      "Hardened the AI Guardian security rail with fail-closed behavior on missing API keys and dangerous-command filtering.",
      "Added structured JSON logging, dual NATS publishing, and Symfony fintech module discovery with full test coverage.",
    ],
  },
  {
    title: "Smart Factory Emission Monitoring",
    tech: "College team project",
    date: "Mar 2026",
    bullets: [
      "Led backend contributions across data ingestion, AI-based recommendation logic, pollution heatmap generation, and a 236-test suite with zero regressions.",
    ],
  },
];

export const heroAvatar = makeBrandTile({
  title: "Sameer Kadam",
  subtitle: "AI Systems Engineer",
  initials: "SK",
  width: 320,
  height: 320,
  accent: "#4e4a85",
});

export const sidebarName = makeBrandTile({
  title: "Sameer",
  subtitle: "AI Systems Engineer",
  initials: "S",
  width: 220,
  height: 92,
  accent: "#4e4a85",
});

export const sidebarMark = makeLetterMark({
  letter: "S",
  width: 160,
  height: 160,
  accent: "#4e4a85",
});

export const loaderMark = makeLetterMark({
  letter: "S",
  width: 180,
  height: 180,
  accent: "#4e4a85",
});

export const contactCoords = [18.679, 73.896];
